import React, { useState } from 'react';
import styled from "styled-components";

import { GiHamburgerMenu } from "react-icons/gi";
import { MdClose } from "react-icons/md";
import { useScroll } from "./useScroll";
import { motion } from "framer-motion";
import { navAnimation } from '../animation'

import { useScrollDirection } from "./useScrollDirection"; // adjust path if needed


function Navbar() {
  const [isNavOpen,setIsNavOpen] = useState(false);
  const [element, controls] = useScroll();
  const scrollDirection = useScrollDirection();
  return <Nav ref={element}
  variants={navAnimation}
  transition={{ delay: 0.1 }}
  animate={controls} 
  state={isNavOpen ? 1 : 0}
  hide={scrollDirection === "down"}
  >
    <div className="brand__container">
      <a href="#home" className='brand'>
      </a>
      <div className="toggle">
        {isNavOpen ? (
          <MdClose onClick={ () => setIsNavOpen(false)} />
        ) : (
          <GiHamburgerMenu
            onClick={ (e) => {
              e.stopPropagation();
              setIsNavOpen(true);
            }}
            />
        )}
      </div>
    </div>
    <div className={`links ${isNavOpen ? "show" : ""}`}>
    <ul>
        <li className="active">
            <a href="#home" onClick={() => setIsNavOpen(false)}>home</a>
          </li>
          <li>
            <a href="#case"onClick={() => setIsNavOpen(false)}>実績</a>
          </li>
          <li>
            <a href="#servicescard"onClick={() => setIsNavOpen(false)}>サービス</a>
          </li>
          <li>
            <a href="#flow"onClick={() => setIsNavOpen(false)}>業務フロー</a>
          </li>
          <li>
            <a href="#menu"onClick={() => setIsNavOpen(false)}>メニュー</a>
          </li>
          <li>
            <a href="#contact"onClick={() => setIsNavOpen(false)}>お問い合わせ</a>
          </li>
        </ul>
    </div>
  </Nav>
}
const Nav = styled(motion.nav)`
position: fixed;
top: ${({ hide }) => (hide ? "-100px" : "0")}; /* Slide up if hide=true */
left: 0;
width: 100%;
z-index: 1000;
display: flex;
justify-content: space-between;
margin: 0 0rem;
background-color: rgba(65, 98, 149, 0.7);
padding-top: 2rem;
transition: top 0.3s ease;    /* Smooth transition */

  .brand__container {
    margin: 0 2rem;
    .toggle {
      display: none;
    }
  }
  .links {
    ul {
      list-style-type: none;
      display: flex;
      gap: 4rem;
      margin-right: 2rem;
      margin-bottom: 10px;
      .active{
        a {
          border-bottom: 0.2rem solid var(--secondary-color);
        }
      }
      li {
        a {
          color: white;
          text-decoration: none;
          font-weight: 400;
          font-size: 0.9rem;
          text-transform: uppercase;
          border-bottom: 2px solid transparent;
          transition: border-bottom 0.2s;
        }
        a:hover {
          border-bottom: 2px solid var(--secondary-color); /* Or your accent color */
        }
      }
    }
  }

  @media screen and (min-width: 280px) and (max-width: 1080px) {
    background-color: rgba(65, 98, 149, 0.7);
    margin: 0;
    position: fixed;
    top: ${({ hide }) => (hide ? "-100px" : "0")};
    left: 0;
    width: 100%;
    z-index: 1000;
    margin-bottom: 0;
    transition: top 0.3s ease;
    .brand__container {
      display: flex;
      justify-content: space-between;
      align-items: center;
      width: 100%;
      .toggle {
        color:white;
        padding-right: 1rem;
        display: block;
        margin-bottom: 1rem;
        z-index: 1;
      }
    }
    .show {
      opacity: 1 !important;
      visibility: visible !important;
    }
    .links {
      position: absolute;
      overflow-x: hidden;
      top: 0;
      right: 0;
      width: ${({ state }) => (state ? "100%" : "0%")};
      height: 100vh;
      background-color: var(--secondary-color);
      opacity: 0;
      visibility: hidden;
      transition: 0.4s ease-in-out;
      ul {
        flex-direction: column;
        text-align: center;
        height: 100%;
        justify-content: center;
        margin-left:2.5rem;
      }
    }
  }
`;
export default Navbar;